<div>
  <h2>JCoB Rule File Content</h2>
  @if (fileContentXML !== null) {
    <pre
      [innerHTML]="fileContentXML"
      style="max-height:600px; overflow:auto; background:#fafafa; border:1px solid #ccc; padding:12px;">
    </pre>
  }
  <button mat-raised-button color="primary" (click)="downloadContent()" [disabled]="!fileContent">
    Download
  </button>
</div>